import {
  OFFERTE_EMOJI,
  OFFERTE_LABEL,
  PROJEKT_TYP_LABEL,
  emojiForProjektTyp,
} from "../constants/projektTypVisuals.js";
import {
  maengelCreatePath,
  offerteCreatePath,
  projektCreatePath,
  serviceCreatePath,
  wartungCreatePath,
} from "./objektHubLinks.js";

/** Reihenfolge wie Kundendaten-Erstellen-Menü */
export const ENTITY_PROJEKT_CREATE_TYPEN = [
  "elektro",
  "pv",
  "sicherheit",
  "ladestation",
  "ladenbau",
  "intern",
];

const PROJEKT_MENU_EMOJI = {
  elektro: "⚡",
  pv: "🔋",
  sicherheit: "🛡️",
  ladestation: "🔌",
  ladenbau: "🏗️",
  intern: "🏠",
};

export function getEntityCreateMenuItems({ showWartung = false } = {}) {
  const items = [
    { target: "offerte", label: `${OFFERTE_EMOJI} ${OFFERTE_LABEL}` },
    ...ENTITY_PROJEKT_CREATE_TYPEN.map((typ) => ({
      target: typ,
      label: `${PROJEKT_MENU_EMOJI[typ] || emojiForProjektTyp(typ)} Projekt · ${PROJEKT_TYP_LABEL[typ] || typ}`,
    })),
    { target: "service", label: "🔧 Serviceauftrag" },
  ];
  if (showWartung) {
    items.push({ target: "wartung", label: "🧰 Wartungsvertrag" });
  }
  items.push({ target: "maengel", label: "🧩 Mängelbericht" });
  return items;
}

export async function confirmKundeBonitaetBeforeCreate(confirm, bonitaetStatus) {
  const status = Number(bonitaetStatus ?? 1);
  if (status === 3) {
    const { ok } = await confirm({
      title: "Kunde gesperrt (Rot)",
      message:
        "Kunde ist als ROT (gesperrt / nur Vorkasse) markiert. Willst du wirklich einen neuen Auftrag / ein neues Projekt erstellen?",
      variant: "danger",
      confirmLabel: "Ja, erstellen",
    });
    return ok;
  }
  if (status === 2) {
    const { ok } = await confirm({
      title: "Hinweis: Kunde Gelb",
      message: "Kunde ist GELB markiert (Zahlungsverhalten beachten). Trotzdem fortfahren?",
      variant: "warning",
      confirmLabel: "Fortfahren",
    });
    return ok;
  }
  return true;
}

export function buildEntityCreatePath(target, { kundeId, objektId } = {}) {
  const kid = Number(kundeId) || null;
  const oid = Number(objektId) || null;
  if (!kid) return null;

  if (target === "offerte") return offerteCreatePath(kid, oid);
  if (target === "service") return serviceCreatePath(kid, oid);
  if (target === "wartung") return wartungCreatePath(kid, oid);
  if (target === "maengel") return maengelCreatePath(kid, oid);
  if (ENTITY_PROJEKT_CREATE_TYPEN.includes(target)) {
    return projektCreatePath(target, kid, oid);
  }
  return null;
}

export function buildEntityCreateState(target, { kundeId, objektId } = {}) {
  const kid = Number(kundeId) || null;
  const oid = Number(objektId) || null;
  if (!kid) return null;

  const prefill = {
    kunde_id: kid,
    kunden_id: kid,
    ...(oid ? { objekt_id: oid } : {}),
  };

  if (target === "offerte") return { path: "/offerten/neu", state: { prefill } };
  if (target === "service") return { path: "/service/neu", state: { prefill } };
  if (target === "wartung") return { path: "/wartungsvertraege/neu", state: { prefill } };
  if (target === "maengel") return { path: "/maengel/neu", state: { prefill } };
  if (ENTITY_PROJEKT_CREATE_TYPEN.includes(target)) {
    return { path: `/projekte/${target}/neu`, state: { prefill } };
  }
  return null;
}

/** Objekt-Hub: Query-Pfade; Kunde ohne Objekt: Router-State. */
export function navigateEntityCreate(navigate, target, { kundeId, objektId } = {}) {
  const kid = Number(kundeId) || null;
  const oid = Number(objektId) || null;
  if (!kid) return false;

  if (oid) {
    const path = buildEntityCreatePath(target, { kundeId: kid, objektId: oid });
    if (!path) return false;
    navigate(path);
    return true;
  }

  const spec = buildEntityCreateState(target, { kundeId: kid });
  if (!spec) return false;
  navigate(spec.path, { state: spec.state });
  return true;
}
